// 登录
<template>
  <div>
    <!-- 邮箱严选广告位 仅163 126 yeah接入 -->
    <div class="g-hd hd-you" v-if="options.youAd">
      <a :href="options.youAd.url">
        <img class="u-logo" v-show="initFlag" :src="options.youAd.img"></img>
      </a>
    </div>
    <!-- END 邮箱严选广告位 仅163 126 yeah接入 -->
    <div class="g-hd"><img class="u-logo" v-show="initFlag" :src="this.options.proLogo" :style="this.options.logoSize" alt="网易邮箱账号" @error="onLogoError"></img></div>
    <div class="g-bd">
      <Form class="m-form iptsBox" ref="form">
         <form-item class="m-ipt ipt-h" prop="account">
              <suggest ref="account" placeholder="用户名" name="account" :suffix="options.suffixDomains" :initialValue="initialValue" @focus="onClearMsg"></suggest>
          </form-item>
        <!-- <div class="u-mLine"><i class="line"></i></div> -->
        <form-item class="m-ipt ipt-pwd" :class="[capType==1?'ipt-m' : 'ipt-f']" prop="pwd">
          <urs-pwdinput ref="pwd" placeholder="密码" :needEye="options.needEye" @focus="onClearMsg" @delete="onClearMsg"></urs-pwdinput>
        </form-item>
        <!-- <div v-show="capType==1" class="u-mLine"><i class="line"></i></div> -->
        <form-item v-if="capType!=0" class="m-ipt ipt-f ipt-cap" :class="
        capclazz" prop="capture">
          <urs-capture
          ref="capture"
          :capKey="options.capKey"
          :aiCapKey="aiCapKey"
          :capType="capType"
          :opd="opd"
          :mail="getFullMail"
          :aicapbtn="aiCapBtn"
          :autoVerify="autoVerify"
           @autoVerify="doAutoVerify"
           @verify="verifyCapture"
           @doVerifyLoading="doVerifyLoading"
           @doAiClose="doAiClose"
           @doVerify="doVerify"
           @initSucc="onCapInit(1)"
           @initError="onCapInit(0)"></urs-capture>
        </form-item>
        <div v-if="repairlink" class="m-repair-guide"><div class="x-box"><a class="x"></a></div>多次输入错误，是否申请修复密码 <a target="_blank" :href=repairlink>修复</a></div>
        <div class="u-clauses g-pd" v-if="options.needUnLogin!==0">
          <div class="u-tips c-main">
            <span @click="onCheckBox"><input type="checkbox" ref="unlogin" :class="[checked?'checked i-checkbox':'i-checkbox']" name="unlogin" ></input><i v-show="checked" class="i-check i-icon i-icon-check"></i></span>
            <label for="unlogin" @click="onCheckBox">{{unLoginTime}}天免登录</label>
          </div>
        </div>
        <div class="m-btns g-pd">
          <div v-show="errorTip" class="errorTip">{{errorTip}}</div>
          <urs-button ref=submitBtn
          :enableTip="nextbtntxt" @click="onLogin">
          </urs-button>
        </div>
      </Form>
    </div>
    <div class="g-ft g-pd clearfix c-main">
      <a class="f-left" href="javascript:void(0)" @click="goFindPwd">忘记密码</a>
      <!--@NOTE 去注册带参数过去 curl=?-->
      <a class="f-right" :href="zcUrl">去注册</a>
    </div>
    <!-- 邮箱app广告位 仅163 126 yeah接入 -->
    <div class="g-mail-ad c-main" v-if="options.showMailAd">
      <!-- 新增电脑版入口 -->
      <a :href="mailUrl" v-if="options.showMailAd">电脑版邮箱登录</a><br/>
      <a href="https://mail.163.com/dashi/dlpro.html?from=mail30" v-if="options.showMailAd">官方邮箱APP，提醒更及时>></a>
    </div>
    <!-- END 邮箱app广告位 仅163 126 yeah接入 -->
    <pre-account :account="preAccount" v-show="preAccount.length>1" @choose="fillAccount" @closeModal="closeModal"></pre-account>
    <PowerCap
      ref="powerCap"
      @sucess="powerSuccess"
    />
  </div>
</template>

<script>
import reqProxy from '../util/request';
import ucon from '../util/constant';
import code from '../util/codemapper';
import util from '../util/util';
import cookie from "../util/cookie";

import PowerCap from './powerCap.vue';

// l接口特定返回码
let loginCode = {
    '804': '加载失败，请稍后再试',
    '803': '加载失败，请稍后再试',
    '805': '加载失败，请稍后再试',
    '806': '加载失败，请稍后再试',
    '413': '账号或密码错误',
    '409': '您登录过于频繁,请稍后再试',
    '402': '当前网络异常，请检查您的网络环境',
    '403': {
        type: 'confirm',
        opt: {
            confirmCnt: '账号存在风险，请先进行验证',
            confirmTxt: '前往验证',
        }
    },
    '416': '您的IP登录过于频繁,请稍后再试',
    '424': {
        type: 'confirm',
        opt: {
            confirmCnt: '该靓号服务已到期，请续费后使用',
            confirmTxt: '去续费',
            closeTxt: '取消',
            confirm: () => {
                location.href = 'https://haoma.163.com/renewal.html?pd=ursmaillogin&pkid=dDiOfyc#/reinfo';
            }
        }
    },
    '421': {
        type: 'confirm',
        opt: { confirmCnt: '账号存在高危风险，请前往<br/>id.163.com修改密码' }
    }, // nei缺
    '425':{
        type: 'confirm',
        opt: {
            confirmCnt: '该账号尚未激活，请到已注册的邮箱激活账号',
            confirmTxt: '激活账号',
            closeTxt: '取消'
        }
    },
    '426': '该账号未及时激活，请重新注册', // nei缺
    '428': {
        type: 'confirm',
        opt: { confirmCnt: '账号存在高危风险，请前往<br/>id.163.com修改密码' }
    },
    '602': {
        type: 'confirm',
        opt: {
            confirmCnt: '邮箱服务已到期，请立即续费',
            confirmTxt: '立即续费',
            closeTxt: '取消',
            confirm: () => {
                location.href =
                    'https://vpay.vip.163.com/center/index.html?sign={{sign}}&from={{product}}&utm_source={{product}}';
            }
        }
    },
    '413-01-confirm': {
        type: 'confirm',
        opt: {
            confirmCnt: '密码错误次数过多，请稍后再试',
            confirmTxt: '找回密码？',
            closeTxt: '取消'
        }
    },
    '413-01': '您登录密码错误次数过多，请稍后再试',
    '412-01': '您登录错误次数过多，请稍后再试',
    '418-01': '您登录成功次数过多,请稍后再试',
    '419-01': '您登录过于频繁,请稍后再试',
    '413-03': '您的IP登录密码错误次数过多，请稍后再试',
    '414-01': '您的IP登录错误次数过多，请稍后再试',
    '417-01': '您的IP登录成功次数过多，请稍后再试',
    '419-02': '您的IP登录过于频繁,请稍后再试'
};
util.merge(loginCode, code);

// pp接口特定返回码
let ppCode = {
    '430': '此次登录不需要进行密保验证'
};
util.merge(ppCode, code);

// toUrl域名白名单正则
const RrlRegExp =
    '^http[s]?://[^?/#]*\\.(((163|16163|126|188|netease|youdao|yodao|lofter|leihuo|lede|lmlc|yunyan|yunyanzx|163yun|arthome163|tryfun|youdaozhixue)\\.com)|(fc18\\.com\\.cn)|((yeah|leihuo)\\.net)|(126\\.am)|((blizzard|yixingame)\\.cn)|(icourse163\\.org)|((netease|yixin)\\.im))((/|\\?|#)\\S*|$)';

const regMail = /^[\w-\.]+@(?:[\w-]+\.)+[a-z]{2,6}$/;
// 登录成功加载跨域写cookie iframe的最长延时
const LOADIFRAME_TIME = 5000;
let pwdErrCountMap = {};
export default {
    name: 'login',

    components: {
        PowerCap
    },

    props: {},
    data() {
        return {
            capType: 0,
            initFlag: 0,
            showSuggest: true,
            capVerifyFlag: false,
            options: ucon,
            opd: '',
            zcUrl: '',
            checked: false,
            preAccount:[],
            initialValue:'',
            repairlink:'',
            aqGuideFlag:0,
            autoVerify:false,
            nextbtntxt:'登录',
            errorTip:'',
            requirePower:false,
            powerData:``,
            pVInfo:``,
            waitPower:false,
            needAutoPowerSubmit: false,
            need805AutoPowerSubmit: false,
            need806AutoPowerSubmit: false,
            hasAuto805Flag: false,
            hasAuto806Flag: false,
            getingPowerInfo: false,
            waitGetPower: false,
            pvSid: ''
        };
    },
    computed: {
        capclazz(){
            if (this.capType === 4 || this.capType === 5){
                return 'cap-s g-pd'
            }
            if (this.capType === 6){
                return 'f-dn'
            }
            return ''
        },
        aiCapBtn(){
            return this.$refs.submitBtn
        },
        getFullMail() {
            return this.$refs.account.getValue()
        },
        unLoginTime() {
            return this.options.needUnLogin === 1
                ? 10
                : this.options.needUnLogin;
        },
        mailUrl() {
            // 默认使用163地址
            let url = 'https://mail.163.com/?dv=pc';
            let host = window.location.host;
            // 126和yeah
            if (host.indexOf('126') !== -1) {
                url = 'https://mail.126.com/?dv=pc';
            } else if (host.indexOf('yeah') !== -1) {
                url = 'https://mail.yeah.net/?dv=pc';
            }
            return url;
        }
    },
    mounted() {
        // 获取并校验url中的参数，若有参数校验不通过则直接返回 不调用初始化接口
        if (!this.getUrlParams()) {
            return;
        }
        // 组成注册链接，curl需要重新encode
        this.zcUrl =
            'https://zc.reg.163.com/m/regInitialized?pd=ursh5mailreg&pkid=KQxvAWV&pkht=id.163.com&' +
            'curl=' +
            encodeURIComponent(this.toUrl);
        this.init();
    },
    beforeDestroy() {
        // @NOTE 实例销毁前清除定时器
        if (this.vfloadsto){
            this.vfloadsto = clearTimeout(this.vfloadsto)
        }
        if (this.sto) {
            window.clearTimeout(this.sto);
        }
    },
    methods: {
        getUserName() {
            let account = this.$refs.account.getValue();
            account = account.trim();
            return account;
        },
        onCheckBox() {
            this.checked = !this.checked;
        },
        // 获取并校验链接中的参数
        getUrlParams() {
            // 根据URL设置默认图标
            window.$NEEDV6 = util.getUrlSearch('v6') || '';
            this.options.proLogo = window.$NEEDV6?'//urswebzj-v6.nosdn.127.net/dl/ner_logo.png':'//ursdoccdn.nosdn.127.net/dl/ner_logo.png';
            // 产品代号 对外称为product 接口传opd
            let opd = util.getUrlSearch('product') || '';
            // product 小写字母或数字或下划线 最长25位
            if (opd && /^[a-z\d_]{1,25}$/.test(opd)) {
                this.opd = opd;
            } else {
                // product 必填 @NOTE 引导到错误页
                this.$emit('changeToError', '缺少或非法的product参数');
                return false;
            }
            // 登录成功跳转页面
            let _toUrl = util.getUrlSearch('curl');
            if (_toUrl) {
                this.toUrl = _toUrl;
            } else {
                // toUrl必填参数且必须合法 @NOTE 引导到错误页
                this.$emit('changeToError', '缺少curl参数或参数非法');
                return false;
            }
            // 主色
            let _mainColor = util.getUrlSearch('mc') || '';
            // 六位数字字母校验
            if (/^[0-9a-zA-Z]{6}$/.test(_mainColor)) {
                util.appendMainColor(_mainColor);
            }
            // 背景主色
            let _backColor = util.getUrlSearch('bc') || '';
            // 六位数字字母校验
            if (/^[0-9a-zA-Z]{6}$/.test(_backColor)) {
                util.appendBackColor(_backColor);
            }
            // 产品配置名称
            let _pdConf = util.getUrlSearch('pdconf') || '';
            // 小写字母、数字下划线 最长25位
            if (/^[0-9a-z_]{1,25}$/.test(_pdConf)) {
                this.pdConf = _pdConf;
            } else {
                this.pdConf = 'yddl_urs_conf';
            }
            // 预置邮箱号码
            let preAccount = util.getUrlSearch('preAccount') || '';
            if(preAccount){
              this.preAccount = preAccount.split(',').slice(0,5);
              // this.preAccount = preAccount.slice(0,5)
            }
            return true;
        },

        validatePreAccount(account) {
          if (!regMail.test(account)) {
            return false;
          }

          const suffix = account.match(/@(?:[\w-]+\.)+[a-z]{2,6}/g).join();
          if (this.options.suffixDomains.indexOf(suffix) === -1) {
            return  false;
          }

          return true;
        },

        // 获取预填写账号
        doPreAccout() {
          const name = localStorage.getItem('urs_h5_dlpage_account');
          if (name && this.validatePreAccount(name)) {
            this.fillAccount(name)
          }
        },

        // 初始化接口调用
        init() {
            // @NEW 增加离线日志参数
            window.$RTID = util.getRtid();
            // 组成参数
            let data = {
                pkht: ucon.pkht,
                pdconf: this.pdConf,
                re: 1
            };
            // 初始化接口
            reqProxy({
                url: '/ini',
                method: 'GET',
                noToast: 1,
                data: data,
                success: data => {

                    this.aiCapKey = data.capId||''
                    // 产品方配置merge
                    if (data.pdConf) {
                        // 与this.options合并
                        try {
                            let conf = JSON.parse(data.pdConf);
                            let zcUrlParams = conf.zcUrlParams||'';
                            if (zcUrlParams){
                                // 如果配置有zcUrlParams地址
                                if(/(^curl=)|(&curl=)/i.test(zcUrlParams)){
                                    // 如果产品误传curl地址，报配置错误
                                    this.$emit('changeToError', '配置中出现非法参数curl');
                                    return;
                                }
                                this.zcUrl = 'https://zc.reg.163.com/m/regInitialized?'+ zcUrlParams + '&curl=' + encodeURIComponent(this.toUrl);
                            }
                            if (window.$NEEDV6 && conf && conf.proLogo && conf.proLogo.indexOf('ursdoccdn.nosdn.127.net')>-1){
                                conf.proLogo = conf.proLogo.replace('ursdoccdn.nosdn.127.net','urswebzj-v6.nosdn.127.net')
                            }
                            // 配置格式检查 @TODO
                            util.merge(this.options, conf);
                            // 默认勾选
                            this.checked = this.options.defaultUnLogin
                            // 过滤预置的邮箱号码
                            this.aqGuideFlag = this.options.aqGuideFlag||0

                        } catch (error) {}
                    }
                    // 验证码配置
                    this.capType = data.capFlag || 0;

                    if (this.capType == 0 || this.capType == 1) {
                        // window.Loading.loading = false;
                        this.initFlag = 1;
                    }
                    let res=[];
                    this.preAccount.forEach(item=>{
                        if(!regMail.test(item)){
                          return
                        }
                        let suffix = item.match(/@(?:[\w-]+\.)+[a-z]{2,6}/g).join()
                        if(this.options.suffixDomains.indexOf(suffix) !== -1&&res.indexOf(item)===-1){
                          res.push(item);
                        }
                    })
                    this.preAccount = res;
                  //当只有一个账号时,直接预填账号
                  if(this.preAccount.length === 1){
                        this.initialValue = this.preAccount[0]
                        //激活密码输入框
                         this.$refs.pwd.focusInput();
                  }

                  if (!this.preAccount.length) {
                    this.doPreAccout();
                  }
                    // toUrl校验正则  报错将tourl设置默认值
                    try {
                        var regExp = new RegExp(data.regExp || RrlRegExp);
                        if (!regExp.test(this.toUrl)) {
                            this.$emit('changeToError', 'curl参数非法');
                        }
                    } catch (error) {
                        this.toUrl = 'https://id.163.com/mail/mailaq/index.html';
                    }
                    //页面初始化完成去掉loading
                     window.Loading.loading = false;

                    if (!!data.pv) {
                      this.getPowerInfo();
                    }
                },
                error: data => {
                    // 错误处理
                    window.Loading.loading = false;
                    this.initFlag = 1;
                    // 特殊提示
                    // 通用错误
                    window.showError(code[data.ret]);

                }
            });
        },

        // 获取算力信息
        getPowerInfo() {
          this.getingPowerInfo = true;
          let url = '/powGetP';
          let data = {
            un: this.getUserName() || this.initialValue || '',
            pvSid: this.pvSid // 算力sid
          }
          reqProxy({
            url: url,
            method: 'GET',
            noToast: 1,
            data: data,
            success: res => {
              // setTimeout(() => {
              this.getingPowerInfo = false;
              // 判断是否需要算力
              this.requirePower = (res.pVInfo && res.pVInfo.needCheck) || false

              const { pVInfo } = res
              if (util.hasPuzzle(pVInfo)){
                  this.pVInfo = pVInfo
                  this.pvSid = pVInfo.sid
              }else{
                  this.pVInfo = ''
                  this.pvSid = ''
              }
              // 如果有题的话，需要算力验证码，立马计算
              this.doWebWorkerPower()

              if (this.needAutoPowerSubmit) {
                if (this.pVInfo) {
                  // 需要自动提交 且获取到了题目信息
                  this.waitPower = true

                  if (this.need805AutoPowerSubmit) {
                    this.hasAuto805Flag = true;
                  }

                  if (this.need806AutoPowerSubmit) {
                    this.hasAuto806Flag = true;
                  }
                  this.getTicket()

                } else {
                  // 需要自动提交，但是没有获取到题目信息
                  this.$refs.submitBtn.state = 'enable';
                  window.showError('加载失败，请稍后再试');
                }

                return;
              }

              if (this.waitGetPower) {
                console && console.log('获取到了，请求')
                this.waitGetPower = false
                this.getTicket()
              }
              //  }, 6000)
            },
            error: data => {
              console && console.log('getPower error')
              this.getingPowerInfo = false;
              if (data.ret === '802') {
                this.requirePower = false; // 算力验证关闭
              }
              if (data.ret === '801'){
                this.pVInfo = ''
                this.requirePower = true
              }

              if (this.needAutoPowerSubmit) {
                this.$refs.submitBtn.state = 'enable';
                window.showError('加载失败，请稍后再试');
                this.clearAutoFlag();
              }

              if (this.waitGetPower) {
                this.waitGetPower = false;
                this.getTicket()
              }
            }
          });
        },

        doWebWorkerPower() {
          if (!util.hasPuzzle(this.pVInfo)) {
            return;
          }

          if (window.Worker) {
            this.$refs.powerCap.doWebWorkerPower(this.pVInfo)
          }
        },

        clearAutoFlag() {
          this.hasAuto805Flag = false;
          this.hasAuto806Flag = false;
        },

        // 验证码切换
        handleCapError(code) {
            // @NOTE 从0-》1切换时，是否能取到索引调用方法？
            let newType = 0;
            switch (code) {
                case '441':
                    window.showError('请输入图片验证码');
                    newType = 1;
                    break;
                case '444':
                    newType = 4;
                    window.showError('请先拖动滑块进行安全验证');
                    break;
                case '445':
                    newType = 5;
                    window.showError('请先进行验证');
                    break;
                case '447':
                    newType = 6;
                    break;
                default:
                    break;
            }
            // 验证码类型未发生变化，需要在父组件刷新验证码
            if (newType === this.capType) {
                this.doRefreshCap(false);
            } else {
                // 否则更新验证码类型，子组件watch到变更，自动刷新或初始化验证码
                this.capType = 0
                this.$nextTick(()=>{
                    this.changeCapFlag(newType);
                })
            }
        },
        // logo获取失败 加载默认logo
        onLogoError() {
            this.options.proLogo = window.$NEEDV6?'//urswebzj-v6.nosdn.127.net/dl/ner_logo.png':'//ursdoccdn.nosdn.127.net/dl/ner_logo.png';
            this.options.logoSize = 'width:auto;height:40px';
        },
        // 验证码初始化结果回调
        onCapInit(state) {
            // 初始化回调返回，隐藏loading
            this.sto = window.setTimeout(() => {
                window.Loading.loading = false;
                this.initFlag = 1;
            }, 50);
            if (state == 1) {
                return;
            }
            // 初始化失败，错误处理？ '系统繁忙，请刷新页面重试'
            window.showError('加载失败，请刷新页面重试');
        },
        goFindPwd(){
            var un = this.$refs.account.getValue()
            if (regMail.test(un)){
                location.href = `https://id.163.com/mail/retrievepassword?username=${un}`
            }else{
                location.href = `https://id.163.com/mail/retrievepassword`
            }
        },
        // 登录按钮点击
        onLogin() {
            // 格式校验
            this.errorTip = ''
            if (util.CapFailCount()){
                window.showError(code['fail5'])
                return
            }
            if (this.validate(this.$refs,['account','pwd'])) {
                this.$refs.submitBtn.state = 'loading';
                this.getTicket()
                // this.verifyCapture();
            }
        },
        validate(refs,array){  //输入框均需要验证
          let children = this.$refs.form.$children,props=[];
          children.forEach(item=>{
            if(item.$options.name=='form-item'){
               props.push(item);
            }
          })
          let errorStatus=true,msg;
          for (let i = 0,item; i < props.length; i++){
              item = props[i]
              msg=item.$children[0].validate();
                if(!msg.status){
                    errorStatus=false;
                    item.setMsg(msg.errorMsg);
                    break
                }
          }
          // if(this.capType!==0){
          //    errorStatus=refs.capture.validate();
          // }
          return errorStatus;
        },
        /**
         * 组成验证码验证参数
         * =>图片验证码-vfcp POST
         * =>滑块验证码-vftcp GET
         * =>点击验证码-vfccp GET
         */
        getVerifyOpt(type) {
            // @TODO 默认的最好能访问
            let opt = {
                url: '/vfcp',
                method: 'GET',
                contentType: 'application/json',
                data: {
                    un: this.$refs.account.getValue()
                }
            };
            switch (type) {
                case 1:
                    // 图片
                    opt.method = 'POST';
                    opt.contentType = 'application/x-www-form-urlencoded';
                    opt.data.cap = this.$refs.capture.getPwd();
                    // opt.data.channel = 2;
                    // delete opt.data.v;
                    break;
                case 4:
                    // 滑块
                    opt.url = '/vftcp';
                    opt.data.cap = this.$refs.capture.getPwd();
                    opt.data.capkey = this.options.capKey;
                    break;
                case 5:
                    // 点击
                    opt.url = '/vfccp';
                    opt.data.cap = this.$refs.capture.getPwd();
                    opt.data.capkey = this.options.capKey;
                    break;
                case 6:
                    // 无感知
                    opt.url = '/vfscp';
                    opt.data.cap = this.$refs.capture.getPwd();
                    break;
                default:
                    break;
            }

            return opt;
        },
        // 验证验证码接口,二次校验
        verifyCapture() {
            // 无验证码
            // if (this.capType === 0) {
            //     return this.getTicket();
            // }
            // 图片验证码和其他验证码接口不同参数不同
            let opt = this.getVerifyOpt(this.capType);
            // 发送请求
            reqProxy({
                url: opt.url,
                method: opt.method,
                contentType: opt.contentType,
                data: opt.data,
                success: data => {
                    // 获取ticket
                    if (this.capType === 6){
                        this.onLogin()
                    }
                },
                error: data => {
                    // 错误处理
                    this.$refs.submitBtn.state = 'enable';
                    if (util.CapFailCount(true)){
                        window.showError(code['fail5'])
                        return;
                    }
                    // 验证码切换？ 441 444 445
                    if (['441','444','445','447'].indexOf(data.ret) !== -1) {
                        this.handleCapError(data.ret);
                        return;
                    }else{
                        // 刷新验证码
                        this.doRefreshCap(false);
                        // 通用错误
                        window.showError(code[data.ret]);
                    }
                }
            });
        },
        doRefreshCap( ischangeed, noshowerr ){
            if (this.capType === 6){
                if (!ischangeed && !noshowerr){
                    this.errorTip = util.filterMsg(this.nextbtntxt)
                }
                this.refreshAiCap( ischangeed )
            }else if (this.capType !== 0){
                this.$refs.capture.refreshCap()
            }
        },

        getTicket() {
          if (this.getingPowerInfo) {
            this.waitGetPower = true;
            return;
          }

          if (this.requirePower && this.pVInfo && !this.powerData) {
            // loading 等待算力结果
            this.waitPower = true;
            if (!window.Worker) {
              // 同步调用一次计算
              console && console.log('同步计算一次');
              this.$refs.powerCap.doSyncCompute(this.pVInfo);
            }
          } else {
            this.waitPower = false;
            this.getRealTicket();
          }
        },

        // 获取ticket接口
        getRealTicket() {
            let url = '/gt';
            let data = {
                un: this.$refs.account.getValue()
            };
            if (this.stodelay){
                this.stodelay = clearTimeout(this.stodelay)
            }
            // gt接口后端有频率限制
            this.stodelay = setTimeout(()=>{
                reqProxy({
                    url: url,
                    method: 'GET',
                    data: data,
                    success: data => {
                        // 登录接口
                        this.doLogin(data.tk);
                    },
                    error: data => {
                        // 错误处理
                        this.$refs.submitBtn.state = 'enable';
                        // 刷新验证码，并且自动校验
                        if (this.capType !== 0) {
                            this.doRefreshCap(false,'noshowerr');
                        }
                        // 通用错误
                        window.showError(code[data.ret]);
                    }
                });
            },200)
        },
        /**
         * 设置多域cookie
         */
        setDomains: (function(urls, endfunc) {
            var count = 0;
            return function(urls, endfunc) {
                if (typeof urls === 'string') {
                    util.insertFrame(urls, this.opd, () => {
                        endfunc();
                    });
                } else if (urls.length > 0) {
                    count = urls.length;
                    this.sto = window.setTimeout(() => {
                        endfunc();
                    }, LOADIFRAME_TIME);
                    for (let i = 0; i < urls.length; i++) {
                        util.insertFrame(urls[i], this.opd, () => {
                            count--;
                            if (count === 0) {
                                endfunc();
                                window.clearTimeout(this.sto);
                            }
                        });
                    }
                } else {
                    endfunc();
                }
            };
        })(),
        //引导模块化
        checkMode(data){
           if(data.nextUrls){
                this.setDomains(data.nextUrls, () => {
                  this.showMode(data.mode,this.toUrl)
                })
            }else{
                this.showMode(data.mode,this.toUrl)
            }
        },
        // 登录成功，设置多域cookie
        loginSuccess(data) {

            this.$refs.submitBtn.state = 'enable';
            if(data.mode){
              this.checkMode(data)
              return
            }
            // 是否设置多域cookie
            if (!data.nextUrls) {
                window.jumpLoading.loading=true;
                location.href = this.toUrl;
                return;
            }
            // 多域cookie
            this.setDomains(data.nextUrls, () => {
                // 无中转页面，直接跳转至toUrl
                window.jumpLoading.loading=true;
                location.href = this.toUrl;
            });
        },
        showMode(data,toUrl){
          data.opd = this.opd
          let _img
          if(data.img0){
             _img= data.img0
             _img = _img.replace('ursdoccdn.nosdn.127.net','urswebzj.nosdn.127.net');
          }
          if(_img&&window.$NEEDV6&&_img.indexOf('urswebzj.nosdn.127.net')>-1){
            data.img0 = this.changeImgtoIPV6(_img)
          }
          this.$emit('changeToMode',data,toUrl)
        },
        changeImgtoIPV6(_url){
          return _url.replace(/\/\/([^\/]+:?)\//,function($1,$2){
          var _host = $2;
          _host = _host.replace(/([^\.]+:?)\./,function($3,$4){
              return $4+'-v6.';
           })
           return '//'+_host+'/';});
        },
        onClearMsg() {
           this.repairlink = '';
        },

        powerSuccess(data) {
            this.powerData = data;
            if (this.waitPower) {
                this.waitPower = false
                this.getRealTicket();
            }
        },

        // 登录接口调用
        doLogin(tk) {
            this.onClearMsg();
            let data = {
                un: this.$refs.account.getValue(),
                tk: tk,
                pw: util.encrypt2(this.$refs.pwd.getValue()),
                domains: this.options.cookieDomains
            };
            // 勾选免登
            if (this.options.needUnLogin && this.checked) {
                data.l = 1;
                data.d = this.unLoginTime;
            }

            // 算力的信息
            if (this.powerData) {
                data.pVParam = this.powerData
                this.powerData = ``;
                this.pVInfo = null;
            }

            this.doRealLogin(data);
        },

        doRealLogin(param){
          let url = '/l';
          reqProxy({
                url: url,
                method: 'POST',
                data: param,
                success: data => {
                    localStorage.setItem('urs_h5_dlpage_account', param.un);
                    this.clearAutoFlag();
                    this.loginSuccess(data);
                },
                error: data => {
                    this.$refs.submitBtn.state = 'enable';
                    // 处理算力，805，804，803
                    // this.powerData = ``;
                    // this.pVInfo = ``;

                    this.needAutoPowerSubmit = false;

                    // 算力校验失败
                    if ((data.ret === '805') && !this.hasAuto805Flag) {
                      // 805 且没有做过自动重试过，则自动提交一次
                      this.needAutoPowerSubmit = true;
                      this.need805AutoPowerSubmit = true;
                    }

                    // 806算力失败
                    if (data.ret === '806' && !this.hasAuto806Flag) {
                      // 806 且没有做过自动重试过，则自动提交一次
                      this.needAutoPowerSubmit = true;
                      this.need806AutoPowerSubmit = true;
                    }

                    if (['804', '803'].indexOf(data.ret) > -1) {
                      if (!this.requirePower || (!util.hasPuzzle(this.pVInfo) && this.pVInfo!==null)) {
                        // 开关从无到有变化的时候自动帮忙进行提交一次(没有开关或者没有题目，都是算力从无到有)
                        this.needAutoPowerSubmit = true;
                      }
                    }
                    // 需要自动重试的情况下，不错误提示，按钮需要加锁
                    if (this.needAutoPowerSubmit) {
                      this.$refs.submitBtn.state = 'loading';
                    }

                    if (['805', '804', '803', '806'].indexOf(data.ret) > -1) {
                      // 不需要自动重试的情况下 进行错误提示
                      if (!this.needAutoPowerSubmit) {
                        window.showError(loginCode[data.ret]);
                        this.clearAutoFlag();
                      }

                      this.getPowerInfo();
                      return;
                    }

                    this.clearAutoFlag();

                    // 需要算力的情况下重新获取算力信息
                    if (this.requirePower) {
                      this.getPowerInfo();
                    }

                    if(data.mode){
                       // 强制不刷新
                      this.changeCapFlag(data.capFlag,'noshowerr','forcenochangeed')
                      this.checkMode(data)
                      return
                    }
                    this.repairlink = '';
                    if (this.aqGuideFlag === 1 && data.ret == '413' && !data.dt){
                        // 带dt的不走此处，aqGuideFlag后端配置开关
                        let account = this.$refs.account.getValue();
                        if (pwdErrCountMap[account]){
                            pwdErrCountMap[account] = ++pwdErrCountMap[account];
                        }else{
                            pwdErrCountMap[account] = 1;
                        }
                        if (pwdErrCountMap[account] && pwdErrCountMap[account]>1){
                            this.repairlink = 'https://id.163.com/mail/retrievepassword?username='+encodeURIComponent(account);
                            if (data.capFlag){
                                this.changeCapFlag(data.capFlag,'noshowerr','forcenochangeed')
                            }
                            return;
                        }
                    }
                    // 风控弱引导，算登录成功
                    if (data.ret == '423') {
                        localStorage.setItem('urs_h5_dlpage_account', param.un);
                        this.loginSuccess(data);
                        return;
                    }
                    // 验证码从无到有 441 444 445
                    if (['441','444','445','447'].indexOf(data.ret) !== -1) {
                        this.handleCapError(data.ret);
                        return;
                    }
                    // 强制不刷新
                    this.changeCapFlag(data.capFlag,'noshowerr','forcenochangeed')
                    // 组成二级返回码，忽略401的二级返回码
                    let ret = data.ret;
                    if (data.dt && ret !== '401') {
                        ret = ret + '-' + data.dt;
                    }
                    // 二次验证 后端功能已下线
                    if (
                        data.pp == '1' &&
                        (ret == '403' ||
                            ret == '429' ||
                            ret == '412-01' ||
                            ret == '413-01' ||
                            ret == '413-03' ||
                            ret == '414-01' ||
                            ret == '417-01' ||
                            ret == '418-01' ||
                            ret == '419-01' ||
                            ret == '419-02')
                    ) {
                        // 是否允许切换模块-二次验证开关打开
                        if (this.options.needpp) {
                            // 二次验证初始化-获取密保信息-二次验证类型
                            let data = {
                                un: this.$refs.account.getValue()
                            };
                            reqProxy({
                                url: '/pp',
                                method: 'GET',
                                data: data,
                                success: data => {
                                    // 切换二次验证方式模块
                                    this.$emit('changeToVerify', {
                                        un: this.$refs.account.getValue(),
                                        data: data
                                    });
                                },
                                error: data => {
                                    // 错误处理
                                    let ret = data.ret
                                    let un = this.$refs.account.getValue()
                                    if (ret === '454'){
                                        ppCode[ret].opt.confirm = util.createConfirm(un)
                                    }
                                    if (ret === '452'){
                                        ppCode[ret].opt.confirm = util.createLogoutConfirm(un)
                                    }
                                    window.showError(ppCode[ret]);
                                }
                            });
                            return;
                        }
                        // 否则进入最后一步通用文案提示
                    }
                    let un = this.$refs.account.getValue()
                    if (data.guideFindPassword && ret === '413-01'){
                        let confirm41301 = '413-01-confirm'
                        loginCode[confirm41301].opt.confirm = util.createFindPwdConfirm(un)
                        window.showError(loginCode[confirm41301]);
                        return
                    }
                    if (ret === '425'){
                        let maillink = util.hasMailLink(un)
                        if (maillink){
                            loginCode[ret].opt.confirm = util.createMailLink(maillink)
                        }else{
                            loginCode[ret].opt.confirm = util.createMailLinkHelp(maillink)
                        }
                    }
                    if (ret === '403'){
                        loginCode[ret].opt.confirm = util.createVerifyLink(un)
                    }
                    if (ret === '454'){
                        loginCode[ret].opt.confirm = util.createConfirm(un)
                    }
                    if (ret === '452'){
                        loginCode[ret].opt.confirm = util.createLogoutConfirm(un)
                    }
                    if (ret === '602'){
                        loginCode[ret].opt.confirm = util.createVipLinkConfirm(data.sign,this.opd)
                    }
                    if (ret === '422'){
                        loginCode[ret].opt.confirm = util.createUnlock(un)
                    }
                    window.showError(loginCode[ret]);
                }
            });

        },
        fillAccount(val){
          //激活密码输入框
          this.$refs.pwd.focusInput();
          this.initialValue = val
        },
        closeModal(){
          //聚焦账号输入框
          this.$refs.account.focusInput();
        },
        doAiClose:function(){
            this.$refs.submitBtn.state = 'enable';
        },
        doVerifyLoading:function(){
            if (this.vfloadsto){
                this.vfloadsto = clearTimeout(this.vfloadsto)
            }
            this.$refs.submitBtn.state = 'loading';
            // this.vfloadsto = setTimeout(()=>{
            //     this.$refs.submitBtn.state = 'enable';
            // },10000)
        },
        doVerify(){
            // 无感知在二次校验,按钮loading
            this.verifyCapture()
        },
        changeCapFlag( capFlag, noshowerr, forcenochangeed ){
            // 验证码切换 以capFlag为准
            if (capFlag && capFlag !== this.capType) {
                this.capType = capFlag;
                let changeed = forcenochangeed?false:true
                this.$nextTick(()=>{
                    this.doRefreshCap(changeed, noshowerr);
                })
            } else if (this.capType !== 0){
                // 刷新验证码
                this.doRefreshCap(false, noshowerr);
            }
        },
        refreshAiCap( autoVerify ) {
            this.capType = 0
            this.autoVerify = autoVerify||false
            if(this.autoVerify){
              this.$refs.submitBtn.state = 'loading';
            }
            this.$nextTick( ()=>{
                this.capType = 6
            } )
        },
        doAutoVerify(){
            // setTimeout(()=>{
                this.onLogin()
            // },100)
        }
    }
};
</script>





// WEBPACK FOOTER //
// Login.vue?01565af5